module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "inbox-compose"
    }
  }, [_c('h1', [_vm._v("Compose New Message")]), _vm._v(" "), _c('form', {
    staticClass: "participants",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('p', [_vm._v("To:\n            "), _vm._l((_vm.addedParticipants), function(participant) {
    return _c('span', {
      staticClass: "participant",
      on: {
        "click": function($event) {
          _vm.removeParticipant(participant)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-minus-circle"
    }), _vm._v("  " + _vm._s(participant.alias))])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addedParticipantName),
      expression: "addedParticipantName"
    }],
    attrs: {
      "id": "newParticipant",
      "type": "text",
      "placeholder": "Search for a Developer",
      "disabled": _vm.formSubmitted
    },
    domProps: {
      "value": (_vm.addedParticipantName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addedParticipantName = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._l((_vm.matchingDevsResponse), function(dev) {
    return (_vm.shouldShowDev(dev)) ? _c('p', {
      staticClass: "new-participant",
      on: {
        "click": function($event) {
          _vm.addParticipant(dev)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-plus-circle"
    }), _vm._v(" " + _vm._s(dev.alias))]) : _vm._e()
  })], 2), _vm._v(" "), (_vm.validationMessage) ? _c('div', {
    staticClass: "validation-messages error"
  }, [_vm._v(_vm._s(_vm.validationMessage))]) : _vm._e(), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMessageSubject),
      expression: "newMessageSubject"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Subject",
      "disabled": _vm.formSubmitted,
      "maxlength": "64"
    },
    domProps: {
      "value": (_vm.newMessageSubject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMessageSubject = $event.target.value
      }
    }
  }), _vm._v(" "), _c('markdown-editor', {
    attrs: {
      "placeholder": "Enter a reply",
      "disabled": _vm.formSubmitted
    },
    model: {
      value: (_vm.newMessageContent),
      callback: function($$v) {
        _vm.newMessageContent = $$v
      },
      expression: "newMessageContent"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Send Message",
      "disabled": _vm.formSubmitted
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitNewConversation($event)
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6da442fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Inbox/InboxCompose.vue
// module id = 889
// module chunks = 2